import Vue from 'vue'
import vSelect from 'vue-select'

Vue.component('v-select', vSelect)


// WEBPACK FOOTER //
// ./src/plugins/select.js